import type { WithTokenParams } from '#src/app/shared/types/payment';

import { useSubmit } from '../useSubmit';

export function useWithToken(): (params: WithTokenParams) => Promise<void> {
	const submit = useSubmit();
	return async function withToken(params): Promise<void> {
		return submit(params);
	};
}
